// vorvani-quantity-breaks-cart-fix.js
//
// PROBLEMA QUE RESUELVE:
// El snippet quantity-breaks.liquid muestra selectores de variante por slot
// (#1, #2, #3...) pero esos <select> NO están conectados al product form.
// Al hacer submit, Shopify recibe {id: <primera_variante>, quantity: N}
// y agrega la misma variante N veces, ignorando las selecciones por slot.
//
// SOLUCIÓN:
// Interceptamos el submit del form (en capture phase, antes de que el
// product-form custom element lo procese) y, cuando hay selectores por slot
// activos, enviamos un items[] separado — un {id, quantity:1} por slot —
// usando la Cart API de Shopify.
 
(function () {
  'use strict';
 
  // ─── Helpers ────────────────────────────────────────────────────────────────
 
  // Lee el JSON de variantes embebido en <quantity-breaks>
  function getVariants(qbEl) {
    var script = qbEl.querySelector('script[type="application/json"]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent.trim()) || [];
    } catch (e) {
      console.error('[VORVANI bundle fix] No se pudo parsear el JSON de variantes:', e);
      return [];
    }
  }
 
  // Encuentra la variante cuyas opciones coincidan exactamente con selectedOptions[]
  function matchVariant(variants, selectedOptions) {
    return variants.find(function (v) {
      var opts = Array.isArray(v.options)
        ? v.options
        : [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
 
      if (opts.length !== selectedOptions.length) return false;
      return opts.every(function (opt, i) {
        return String(opt) === String(selectedOptions[i]);
      });
    });
  }
 
  // Devuelve el ID de variante para un slot individual
  function getSlotVariantId(selectorItem, variants) {
    var selects = Array.from(
      selectorItem.querySelectorAll('select.variant-dropdown, select.select__select, select')
    );
 
    if (selects.length === 0) {
      // Fallback: usa el data-selected-id del slot
      return parseInt(selectorItem.dataset.selectedId, 10) || null;
    }
 
    var selectedOptions = selects.map(function (s) { return s.value; });
    var matched = matchVariant(variants, selectedOptions);
 
    if (matched) return matched.id;
 
    console.warn('[VORVANI bundle fix] Variante no encontrada para opciones:', selectedOptions);
    return parseInt(selectorItem.dataset.selectedId, 10) || null;
  }
 
  // Devuelve el <label> de la opción de bundle actualmente seleccionada
  function getActiveLabel() {
    var checked = document.querySelector(
      '.quantity-breaks-container input[type="radio"]:checked'
    );
    if (!checked) return null;
    return document.querySelector('label[for="' + checked.id + '"]');
  }
 
  // Construye el array de items para la Cart API
  // Agrupa variantes iguales en un solo line item con quantity acumulada,
  // para que el descuento automático "mínimo N artículos" se dispare
  // incluso cuando el tema envía una variante por slot.
  function buildCartItems(qbEl) {
    var label = getActiveLabel();
    if (!label) return null;
 
    var selectorItems = Array.from(
      label.querySelectorAll('.quantity-break__selector-item')
    );
    if (selectorItems.length === 0) return null;
 
    var variants = getVariants(qbEl);
    var grouped = {}; // { variantId: { id, quantity } }
 
    selectorItems.forEach(function (item) {
      var variantId = getSlotVariantId(item, variants);
      if (!variantId) return;
 
      if (grouped[variantId]) {
        grouped[variantId].quantity += 1;
      } else {
        grouped[variantId] = { id: variantId, quantity: 1 };
      }
    });
 
    var items = Object.keys(grouped).map(function (k) { return grouped[k]; });
    return items.length > 0 ? items : null;
  }
 
  // ─── Precio dinámico por slot ────────────────────────────────────────────
 
  // Igual que getSlotVariantId pero devuelve el price (en centavos) en vez del id
  function getSlotVariantPrice(selectorItem, variants) {
    var selects = Array.from(
      selectorItem.querySelectorAll('select.variant-dropdown, select.select__select, select')
    );
 
    var variant;
    if (selects.length === 0) {
      var fallbackId = parseInt(selectorItem.dataset.selectedId, 10);
      variant = variants.find(function (v) { return v.id === fallbackId; });
    } else {
      var selectedOptions = selects.map(function (s) { return s.value; });
      variant = matchVariant(variants, selectedOptions);
    }
 
    return variant ? variant.price : null; // price en centavos (Shopify lo da × 100)
  }
 
  // Formatea centavos como "$ NNN" (igual que text-with-price.liquid)
  function fmtCents(cents) {
    var pesos = Math.floor(cents / 100);
    // Agrega separador de miles con coma (1,049 → "1,049")
    return '$ ' + pesos.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
 
  // Recalcula y actualiza el precio mostrado del bundle activo
  function updateLivePrice(qbEl) {
    var label = getActiveLabel();
    if (!label) return;
 
    var selectorItems = Array.from(label.querySelectorAll('.quantity-break__selector-item'));
    if (selectorItems.length === 0) return;
 
    var variants = getVariants(qbEl);
    var percentageLeft = parseFloat(label.dataset.percentageLeft);
    var fixedAmountOff  = parseInt(label.dataset.fixedAmountOff, 10);
 
    if (isNaN(percentageLeft) || isNaN(fixedAmountOff)) return;
 
    // Sumar precios de todos los slots
    var totalCents = 0;
    var allFound = true;
 
    selectorItems.forEach(function (item) {
      var p = getSlotVariantPrice(item, variants);
      if (p != null) {
        totalCents += p;
      } else {
        allFound = false;
      }
    });
 
    if (!allFound) return;
 
    // Misma fórmula que el snippet Liquid:
    // option_X_price = price × quantity × percentage_left − fixed_amount_off
    // Aquí: totalCents ya es la suma slot a slot (equivale a price × quantity con precios mixtos)
    var bundleCents = Math.round(totalCents * percentageLeft) - fixedAmountOff;
    if (bundleCents < 0) bundleCents = 0;
 
    var bundleFmt = fmtCents(bundleCents);
 
    // Actualiza el span de precio total del bundle (.quantity-break__price > span)
    var priceEl = label.querySelector('.quantity-break__price');
    if (priceEl) {
      var priceSpan = priceEl.querySelector('span');
      if (priceSpan) priceSpan.textContent = bundleFmt;
    }
 
    // Actualiza precio en el badge si también muestra el precio total
    var badgeEl = label.querySelector('.quantity-break__badge');
    if (badgeEl) {
      var badgeSpan = badgeEl.querySelector('span');
      if (badgeSpan && /^\$\s*[\d,]+$/.test(badgeSpan.textContent.trim())) {
        badgeSpan.textContent = bundleFmt;
      }
    }
 
    // Actualiza "precio por unidad" en label-text si existe
    var quantity = selectorItems.length || 1;
    var priceEachCents = Math.round(bundleCents / quantity);
    var priceEachFmt = fmtCents(priceEachCents);
 
    // Busca spans en label-text / benefit / caption que contengan precio (heurística: "$ NNN")
    label.querySelectorAll(
      '.quantity-break__label-text span, .quantity-break__benefit span, .quantity-break__caption span'
    ).forEach(function (span) {
      if (/^\$\s*[\d,]+$/.test(span.textContent.trim())) {
        // Si el valor es igual al precio total o al precio por unidad del render inicial,
        // actualizamos con el equivalente correspondiente
        // (heurística: si el span tiene hermanos de texto que sugieren "c/u" o "each")
        var parent = span.parentElement;
        var parentText = parent ? parent.textContent : '';
        if (/c\/u|cada|each|por set/i.test(parentText)) {
          span.textContent = priceEachFmt;
        } else {
          span.textContent = bundleFmt;
        }
      }
    });
  }
 
  // Instala listeners para actualizar el precio al cambiar slot o bundle
  function installPriceListeners(qbEl) {
    // Cambio en dropdown de variante de cualquier slot
    qbEl.addEventListener('change', function (evt) {
      if (
        evt.target &&
        evt.target.matches(
          'select.variant-dropdown, select.quantity-break__variant-select, select.select__select'
        )
      ) {
        updateLivePrice(qbEl);
      }
    });
 
    // Cambio de opción de bundle (radio quantity1 / quantity2 / …)
    var container = qbEl.querySelector('.quantity-breaks-container');
    if (container) {
      container.addEventListener('change', function (evt) {
        if (evt.target && evt.target.type === 'radio' && evt.target.name === 'quantity') {
          // Pequeño delay para que el DOM refleje la nueva selección antes de leer
          setTimeout(function () { updateLivePrice(qbEl); }, 30);
        }
      });
    }
 
    // Correr una vez al cargar para inicializar con la variante seleccionada por defecto
    updateLivePrice(qbEl);
  }
 
  // ─── Intercepcón del submit ───────────────────────────────────────────────
 
  function handleSubmit(evt) {
    var qbEl = document.querySelector('quantity-breaks');
    if (!qbEl) return; // No hay bundle en esta página
 
    // Solo interceptar si la opción activa tiene selectores por slot
    var activeLabel = getActiveLabel();
    if (!activeLabel) return;
 
    var hasSelectorItems = activeLabel.querySelector('.quantity-break__selector-item');
    if (!hasSelectorItems) return; // Sin selectores: el submit normal funciona bien
 
    // ── Tomamos el control del submit ────────────────────────────────────────
    evt.preventDefault();
    evt.stopImmediatePropagation(); // Evita que product-form lo procese también
 
    var items = buildCartItems(qbEl);
 
    if (!items || items.length === 0) {
      console.warn('[VORVANI bundle fix] No se pudieron leer las variantes por slot. Usando submit normal.');
      // Fallback: formulario nativo (no ideal pero no rompe la compra)
      var form = evt.target;
      var fallbackFetch = new FormData(form);
      fetch(
        (window.routes && window.routes.cart_add_url) || '/cart/add.js',
        { method: 'POST', body: fallbackFetch }
      ).then(function () {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      });
      return;
    }
 
    // ── Estado de carga ──────────────────────────────────────────────────────
    var form = evt.target;
    var productFormEl = form.closest('product-form');
    var submitBtn = productFormEl
      ? productFormEl.querySelector('[type="submit"]')
      : form.querySelector('[type="submit"]');
    var spinner = productFormEl
      ? productFormEl.querySelector('.loading-overlay__spinner')
      : null;
 
    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('loading');
    }
    if (spinner) spinner.classList.remove('hidden');
 
    // ── Preparar payload ──────────────────────────────────────────────────────
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
 
    var sections = 'cart-drawer,cart-icon-bubble';
    if (cart && typeof cart.getSectionsToRender === 'function') {
      try {
        sections = cart.getSectionsToRender()
          .map(function (s) { return s.section || s.id; })
          .join(',');
      } catch (e) { /* usa el valor por defecto */ }
    }
 
    if (cart && typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(document.activeElement);
    }
 
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
 
    // ── Llamada a la Cart API ─────────────────────────────────────────────────
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || 'Error al agregar al carrito');
        }
 
        // Shrine necesita data.id en renderContents
        if (!data.id && data.items && data.items[0]) {
          data.id = data.items[0].id || data.items[0].variant_id;
        }
 
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        console.error('[VORVANI bundle fix] Error al agregar el bundle:', err);
 
        var errorWrapper = productFormEl
          ? productFormEl.querySelector('.product-form__error-message-wrapper')
          : null;
        var errorMsg = errorWrapper
          ? errorWrapper.querySelector('.product-form__error-message')
          : null;
 
        if (errorWrapper) errorWrapper.removeAttribute('hidden');
        if (errorMsg) errorMsg.textContent = err.message || 'No se pudo agregar el bundle al carrito.';
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
      });
  }
 
  // Instala el listener en capture phase (antes del listener del product-form)
  function installOnForm(form) {
    form.addEventListener('submit', handleSubmit, true);
  }
 
  // ─── Inicialización ───────────────────────────────────────────────────────
 
  function init() {
    // Formularios de producto presentes en el DOM
    var forms = document.querySelectorAll(
      'product-form form[action*="/cart/add"], form[data-type="add-to-cart-form"]'
    );
 
    forms.forEach(installOnForm);
 
    // Precio dinámico por slot
    var qbEl = document.querySelector('quantity-breaks');
    if (qbEl) {
      installPriceListeners(qbEl);
    }
 
    // Si el DOM aún no tiene el form o el quantity-breaks, esperar con MutationObserver
    if (forms.length === 0 || !qbEl) {
      var observer = new MutationObserver(function () {
        var newForms = document.querySelectorAll(
          'product-form form[action*="/cart/add"], form[data-type="add-to-cart-form"]'
        );
        var newQb = document.querySelector('quantity-breaks');
 
        if (newForms.length > 0 && forms.length === 0) {
          newForms.forEach(installOnForm);
        }
        if (newQb && !qbEl) {
          qbEl = newQb;
          installPriceListeners(qbEl);
        }
        if (newForms.length > 0 && newQb) {
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
 